module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAOCAYAAADwikbvAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAMVJREFUeNpi/P//PwM6kDh2XwtILQLif0Cc8sJK8RIDFsDEgB3oA7ExEJsCcSUONTg1I4sbA13CTIrmKCT2N6Cz/xKlGWhLEJDyQhK6hMvZjMgBBtSoAKROArEYkponUMwI5cM0LGYBaugFMpRAoQrEdWgaQUAGitHBaxYgkQvErEAMMkSEgXjwHeTnr0jO+UOCZpyhTZReSjS/IFfzFyCexgQNLAZoVLAQqbkDmHCugxS/BGIBIP4BZb8joPE+NGYYAAIMACjqL9d66VQvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/clubActivity/icons/like.png
// module id = 74
// module chunks = 453